import { io } from "socket.io-client";

//const URL = "http://192.168.14.187:4000";
 const URL = "https://imedilchat.imedil.ge/";
 //const URL = "10.45.80.90";


const socket = io(URL, 
{
   
  transports: ["websocket"],
  path: '/socket.io'
}
);

// eslint-disable-next-line no-unused-vars
socket.onAny((event, ...args) => {

});

export default socket;